import * as XLSX from "xlsx";

/**
 * Downloads tabular data as a real .xlsx workbook. Row keys become the header
 * row; pass already-formatted display values (resolved member names, formatted
 * money) so the spreadsheet reads like the grid it came from.
 */
export function exportToExcel(fileName: string, rows: Record<string, string | number>[]): void {
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Export");
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
}
